/* eslint-disable @angular-eslint/no-input-rename */

import { AsyncPipe, NgClass } from "@angular/common";
import { Component, Input, ChangeDetectionStrategy } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { ValsSynkroniseringsstatusTyp } from "~app/common/models/constants";
import { ObjectUtils } from "~app/common/utils/object-utils";
import { IArbetsorderStatusIcons } from "./arbetsorder-status-ikoner-models";

@Component({
    selector: "rask-arbetsorder-status-ikoner",
    templateUrl: "./arbetsorder-status-ikoner.component.html",
    styleUrls: ["./arbetsorder-status-ikoner.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        NgClass,
        AsyncPipe
    ]
})
export class ArbetsorderStatusIkonerComponent {

    @Input() arbetsorderStatusIcons: IArbetsorderStatusIcons;
    @Input() arbetsorderValsSynkroniseringstatus: string;
    @Input("showSpinner") showSpinner$ = new BehaviorSubject<boolean>(false);
    @Input() restriktionEjKlar?: boolean;
    @Input() restriktionHanterad?: boolean;

    @Input("showViol3Spinner") showViol3Spinner$ = new BehaviorSubject<boolean>(false);
    @Input("virkeskopIcon") virkeskopIcon$ = new BehaviorSubject<string>("initial");
    @Input("viol3Icon") viol3Icon$ = new BehaviorSubject<string>("initial");
    private readonly iconErrorClass = "table-cell-icon-error";
    private readonly iconSelectedClass = "table-cell-icon-selected";

    getIkonKlassValssynkroniseringsstatus(): string {
        if (
            this.arbetsorderValsSynkroniseringstatus ===
            ValsSynkroniseringsstatusTyp.Fel
        ) {
            return this.iconErrorClass;
        } else if (
            this.arbetsorderValsSynkroniseringstatus ===
            ValsSynkroniseringsstatusTyp.Skickad ||
            this.arbetsorderValsSynkroniseringstatus ===
            ValsSynkroniseringsstatusTyp.Mottagen
        ) {
            return this.iconSelectedClass;
        }

        return "";
    }

    getRestriktionIcon(): string {
        if (this.restriktionEjKlar) {
            return "fa-solid fa-circle-minus text-danger";
        } else {
            return "fa-solid fa-circle-minus table-cell-icon-selected";
        }
    }

    shouldShowRestriktionIcon() {
        return this.arbetsorderStatusIcons.restriktionIconVisible &&
            (ObjectUtils.hasValue(this.restriktionHanterad) ||
                ObjectUtils.hasValue(this.restriktionEjKlar));
    }

}
